var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3Dcube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2666 2.38333L16.6916 5.30833C17.325 5.64999 17.325 6.62499 16.6916 6.96666L11.2666 9.89166C10.7833 10.15 10.2166 10.15 9.73331 9.89166L4.30831 6.96666C3.67498 6.62499 3.67498 5.64999 4.30831 5.30833L9.73331 2.38333C10.2166 2.12499 10.7833 2.12499 11.2666 2.38333Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50835 8.94167L8.55002 11.4667C9.17502 11.7833 9.57502 12.425 9.57502 13.125V17.8917C9.57502 18.5833 8.85002 19.025 8.23335 18.7167L3.19169 16.1917C2.56669 15.875 2.16669 15.2333 2.16669 14.5333V9.76667C2.16669 9.075 2.89169 8.63333 3.50835 8.94167Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4917 8.94167L12.45 11.4667C11.825 11.7833 11.425 12.425 11.425 13.125V17.8917C11.425 18.5833 12.15 19.025 12.7667 18.7167L17.8083 16.1917C18.4333 15.875 18.8333 15.2333 18.8333 14.5333V9.76667C18.8333 9.075 18.1083 8.63333 17.4917 8.94167Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Dcube);
export default __webpack_public_path__ + "static/media/3dcube.2b6cb8127bd0033181e4c5cfc7677912.svg";
export { ForwardRef as ReactComponent };